export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14862.0b3bae90.jpg";